import * as Types from '../../modules/decisionsNext/api/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type DeleteFilterMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteFilterMutation = { __typename?: 'Mutation', deleteFilter: { __typename?: 'StoredFiltersDeleteResponse', success: boolean } };

export type UpdateFilterLastUsedMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type UpdateFilterLastUsedMutation = { __typename?: 'Mutation', updateFilterLastUsed: { __typename?: 'StoredFiltersUpdateLastUserResponse', success: boolean } };


export const DeleteFilterDocument = gql`
    mutation DeleteFilter($id: ID!) {
  deleteFilter(id: $id) {
    success
  }
}
    `;
export type DeleteFilterMutationFn = Apollo.MutationFunction<DeleteFilterMutation, DeleteFilterMutationVariables>;

/**
 * __useDeleteFilterMutation__
 *
 * To run a mutation, you first call `useDeleteFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilterMutation, { data, loading, error }] = useDeleteFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFilterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFilterMutation, DeleteFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFilterMutation, DeleteFilterMutationVariables>(DeleteFilterDocument, options);
      }
export type DeleteFilterMutationHookResult = ReturnType<typeof useDeleteFilterMutation>;
export type DeleteFilterMutationResult = Apollo.MutationResult<DeleteFilterMutation>;
export type DeleteFilterMutationOptions = Apollo.BaseMutationOptions<DeleteFilterMutation, DeleteFilterMutationVariables>;
export const UpdateFilterLastUsedDocument = gql`
    mutation UpdateFilterLastUsed($id: ID!) {
  updateFilterLastUsed(id: $id) {
    success
  }
}
    `;
export type UpdateFilterLastUsedMutationFn = Apollo.MutationFunction<UpdateFilterLastUsedMutation, UpdateFilterLastUsedMutationVariables>;

/**
 * __useUpdateFilterLastUsedMutation__
 *
 * To run a mutation, you first call `useUpdateFilterLastUsedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFilterLastUsedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFilterLastUsedMutation, { data, loading, error }] = useUpdateFilterLastUsedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFilterLastUsedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFilterLastUsedMutation, UpdateFilterLastUsedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFilterLastUsedMutation, UpdateFilterLastUsedMutationVariables>(UpdateFilterLastUsedDocument, options);
      }
export type UpdateFilterLastUsedMutationHookResult = ReturnType<typeof useUpdateFilterLastUsedMutation>;
export type UpdateFilterLastUsedMutationResult = Apollo.MutationResult<UpdateFilterLastUsedMutation>;
export type UpdateFilterLastUsedMutationOptions = Apollo.BaseMutationOptions<UpdateFilterLastUsedMutation, UpdateFilterLastUsedMutationVariables>;